export default (el) => {
    window.onscroll = () => {
        if (window.scrollY > window.innerHeight) {
            el.classList.remove('top-link--hidden')
        } else {
            el.classList.add('top-link--hidden')
        }
    }
}
